import React from "react";
import { Col, Container, Image, Row } from "react-bootstrap";
import GreyScaleImageOfJosh from "../img/why-choose-me.webp";

export const WhyChooseMeSection = () => {
  return (
    <Container
      fluid
      as="section"
      className="why-choose-me-section"
      data-aos="fade-up"
    >
      <Container>
        <Row>
          <Col sm="12" md="12" lg="5">
            <h2 data-aos="fade-right">Why Choose Me?</h2>
            <p data-aos="fade-left">
              There are plenty of sessions drummers to choose from, but many of
              them focus on a key style and therefore can limit themselves to a
              specific genre which means they struggle to break out of their set
              formula when they transition to a style they are unfamiliar with,
              this is not a problem for me as a big part of what I do when I am
              working is allowing myself to feel a song and contribute something
              unique to it, whilst keeping my playing style relevant to the
              genre I am playing too.
            </p>
          </Col>
          <Col sm="12" md="12" lg="2"></Col>
          <Col sm="12" md="12" lg="5">
            <Image
              fluid
              data-aos="fade-up"
              src={GreyScaleImageOfJosh}
              alt="Greyscale image of josh playing drums in the studio"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
};
